import { Box, Stack, Typography } from '@mui/material';

import { useTheme } from 'src/provider/ThemeCustomizationProvider';
import { combineHexAndOpacity } from 'src/utils/helpers';

import { ThemePreviewLayout } from './ThemePreviewLayout';

export function HomepagePreview() {
  const { theme } = useTheme();

  const headingColor = combineHexAndOpacity(theme.text.heading.color, theme.text.heading.opacity);
  const paragraphColor = combineHexAndOpacity(theme.text.paragraph.color, theme.text.paragraph.opacity);
  const containerColor = combineHexAndOpacity(theme.theme.container.color, theme.theme.container.colorOpacity);
  const secondaryColor = combineHexAndOpacity(
    theme.theme.bgColorButton.secondary,
    theme.theme.bgColorButton.secondaryOpacity,
  );
  const primaryColor = combineHexAndOpacity(
    theme.theme.bgColorButton.primary,
    theme.theme.bgColorButton.primaryOpacity,
  );

  const renderBars = (count: number, width: string | number = '100%') =>
    Array.from({ length: count }).map((_, index) => (
      <Box key={index} width={width} height='4.08px' borderRadius='0.6px' bgcolor={paragraphColor} />
    ));

  return (
    <ThemePreviewLayout theme={theme}>
      <Stack padding='11.02px 10px' direction='row' justifyContent='space-between' spacing='19.7px'>
        {/* Left Section */}
        <Box width='64%'>
          <Typography fontSize='7.34px' color={headingColor} fontWeight={theme.text.heading.fontWeight}>
            Project Name
          </Typography>
          <Typography
            paddingTop='6.3px'
            fontSize='3.67px'
            color={paragraphColor}
            fontWeight={theme.text.paragraph.fontWeight}>
            A short description about your project...
          </Typography>
          <Stack spacing='2.45px' width='100%' paddingTop='6.3px'>
            {renderBars(3)}
            {renderBars(1, '46px')}
          </Stack>
          <Box width='100%' marginTop='6.53px' height='98px' borderRadius='2.45px' bgcolor={containerColor} />
        </Box>

        {/* Right Section */}
        <Box width='36%'>
          <Stack direction='row' alignItems='center' spacing='2.45px'>
            <Box width='9.79px' height='9.79px' borderRadius='100%' bgcolor={containerColor} />
            <Box width='32.8px' height='9.79px' borderRadius='0.81px' bgcolor={containerColor} />
          </Stack>
          <Box width='28.5px' height='6.53px' marginTop='5.71px' borderRadius='0.81px' bgcolor={containerColor} />
          <Stack
            direction='row'
            alignItems='center'
            spacing='4.9px'
            padding='4.08px 4.9px'
            marginTop='5.71px'
            bgcolor={containerColor}
            borderRadius='3.26px'
            sx={{ backdropFilter: 'blur(2.24px)' }}>
            <Box width='9.79px' height='9.79px' borderRadius='100%' bgcolor={containerColor} />
            <Box>
              <Box width='29.5px' height='4.89px' borderRadius='0.81px' bgcolor={containerColor} />
              <Box width='15.3px' height='3.2px' marginTop='1.63px' borderRadius='0.81px' bgcolor={containerColor} />
            </Box>
          </Stack>
          <Stack direction='row' alignItems='center' justifyContent='space-between' marginTop='5.71px'>
            <Stack direction='row' alignItems='center' spacing='2.45px'>
              <Box width='28.5px' height='6.53px' borderRadius='0.81px' bgcolor={containerColor} />
              <Box width='4.89px' height='4.89px' borderRadius='100%' bgcolor={containerColor} />
            </Stack>
            <Box width='15.5px' height='6.53px' borderRadius='0.81px' bgcolor={secondaryColor} />
          </Stack>
          <Stack direction='row' alignItems='center' justifyContent='space-between' spacing='3.26px' marginTop='5.71px'>
            <Box width='100%' height='12.24px' padding='1px' borderRadius='3.26px' bgcolor={containerColor}>
              <Box width='70%' height='100%' borderRadius='3.26px' bgcolor={secondaryColor} />
            </Box>
            <Box width='26.9px' height='12.24px' borderRadius='0.81px' bgcolor={containerColor} />
          </Stack>
          <Stack spacing='2.45px' width='100%' paddingTop='7.96px'>
            {renderBars(4)}
          </Stack>
          <Stack spacing='2.45px' width='100%' paddingTop='7.96px'>
            {renderBars(4)}
          </Stack>
          <Box marginTop='6.67px' height='10.6px' width='100%' borderRadius='0.81px' bgcolor={primaryColor} />
        </Box>
      </Stack>
    </ThemePreviewLayout>
  );
}
